export default __webpack_public_path__ + "static/media/Pot1.8eef62ac.svg";